import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { appointmentAsMemberQueryKeys } from "./appointmentAsMemberQueryKeys";

export const useQueryAppointmentIdAsMember = ({
  api,
  id,
  enabled = true,
}: {
  api: ApiType;
  id: Parameters<ApiType["customerAppointmentApi"]["id"]>[0];
  enabled?: boolean;
}) =>
  useQuery({
    queryKey: appointmentAsMemberQueryKeys.id(id),
    queryFn: async () => (await api.customerAppointmentApi.id(id)).data,
    enabled,
  });
